 function makeXhr(method, url, data, domain, onSuccess, onError) {
    var xhttp = new XMLHttpRequest();
    xhttp.open(method, url, true);
    xhttp.setRequestHeader('Content-type', 'application/json');
    xhttp.setRequestHeader('x-shopify-shop-domain', domain);
    xhttp.onload = function () {
      if (xhttp.status == 200) {
        onSuccess && onSuccess();
      } else {
        onError && onError();
      }
    };
    xhttp.send(data ? JSON.stringify(data) : null);
  }  
  function notifyOnWhatsApp(button) {    
    if (!(button instanceof HTMLElement)) {
      button = event?.target || document.querySelector('#notify__button');
    }
  
    const container = button.closest('.whatsapp-notifyme--container');
    if (!container) return;
  
    const info = container.querySelector('#notify__text');
    const productId = info?.getAttribute('data-productId');
    const productTitle = info?.getAttribute('data-productTitle');
    const currentVariantId = document.getElementsByName("id")[0]?.value;
    const nationalCode = container.querySelector('#countryCode');
    const responseText = container.querySelector('.response-message--text');
    const domain = window.location.hostname;
  
    if (info?.value) {
      const data = {
        phone: nationalCode.value.toString() + info.value,
        variant_id: currentVariantId,
        product_id: productId,
        product_title: productTitle,
        variant_url: window.location.href,
      };
  
      button.classList.add('is-loading');
      button.textContent = '';
  
      makeXhr(
        'POST',
        'https://iy08ni8pq5.execute-api.ap-south-1.amazonaws.com/api/notify/api',
        data,
        domain,
        () => {
          responseText.textContent = 'Your Whatsapp notification request has been registered';
          responseText.classList.add('success');
          button.classList.remove('is-loading');
          button.textContent = 'REMIND ME';
        },
        () => {
          responseText.textContent = 'Your Whatsapp notification request has failed';
          responseText.classList.add('failed');
          button.classList.remove('is-loading');
          button.textContent = 'REMIND ME';
        }
      );
    } else {
      alert('Please provide the phone number');
    }
  }
  
  function bindNotifyMePopupEvents() {
    const containers = document.querySelectorAll('.whatsapp-notifyme--container');
  
    containers.forEach((container) => {
      const openBtn = container.querySelector('.whatsapp-notifyme--button');
      const closeBtn = container.querySelector('.close-notifyme-form');
  
      if (openBtn && !openBtn._bound) {
        openBtn.addEventListener('click', () => {
          container.classList.add('show-notifyme-popup');
        });
        openBtn._bound = true;
      }
  
      if (closeBtn && !closeBtn._bound) {
        closeBtn.addEventListener('click', () => {
          container.classList.remove('show-notifyme-popup');
        });
        closeBtn._bound = true;
      }
    });
  }
  
  const observer = new MutationObserver(() => {
    bindNotifyMePopupEvents();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
  
  bindNotifyMePopupEvents();
  